<script setup lang="ts">
const { name, routes } = defineProps<{
  name: string
  routes: Array<{
    url: string
    label: string
    parents?: Array<{
      label: string
    }>
  }>
}>()

const {
  highlight,
  search,
  closeDialog,
} = useQuickSearch()
</script>

<template>
  <div
    v-if="routes.length > 0"
    class="search__group"
    :aria-label="name"
    role="group"
  >
    <div class="search__heading">
      <span aria-hidden="true">{{ name }}</span>
      <AppLink
        :to="`/search/?q=${search}`"
        class="search__link-all"
        :aria-label="$t('View all results for {search}', { search })"
      >
        {{ $t('View all') }}
      </AppLink>
    </div>

    <ul class="search__list">
      <li
        v-for="route in routes"
        :key="route"
        class="search__item"
      >
        <AppLink
          :to="`/${route.url}/`"
          class="search__link"
          @click="closeDialog"
        >
          <span class="search__label">
            <UiRichtext :html="highlight(route.label + (route?.parents?.[0]?.label ? ' in ' + route.parents[0].label : ''))" />
          </span>
        </AppLink>
      </li>
    </ul>
  </div>
</template>

<style>
/* @import url("~layers/components/Search/ResultRoutes.css"); */
</style>
